const sendingOption = {
    sendToMe: 'sendToMe',
    sendToSomeoneElse: 'sendToSomeoneElse'
};

export default sendingOption;